import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import YourEvents from "./pages/YourEvents";
import Automotive from "./pages/Automotive";
import Attending from "./pages/Attending";
import Home from "./pages/Home";
import Sports from "./pages/Sports";
import EventDetails from "./pages/EventDetails"; 
import CreateEvent from "./pages/CreateEvent"; 
import Login from "./pages/Login"; 
import SignUp from "./pages/SignUp"; 
import Settings from "./pages/Settings"; 
import Support from "./pages/Support"; 
import AdminReports from "./pages/AdminReports"; 
import NewsArticle from "./pages/NewsArticle"; 
import News from "./pages/News"; 
import NewsAdmin from "./pages/NewsAdmin"; 
import Music from "./pages/Music"; 
import Groups from "./pages/Groups.jsx";
import CreateGroup from "./pages/CreateGroup.jsx";
import Group from "./pages/Group.jsx";

function App() {
  return (
      <Router>
        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/Automotive" element={<Automotive />} />
          <Route path="/YourEvents" element={<YourEvents />} />
          <Route path="/Attending" element={<Attending />} />
          <Route path="/Sports" element={<Sports />} />
          <Route path="/CreateEvent" element={<CreateEvent />} />
          <Route path="/event/:eventUrlKey/:eventSlug" element={<EventDetails />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/SignUp" element={<SignUp />} />
          <Route path="/Settings" element={<Settings />} />
          <Route path="/Support" element={<Support />} />
          <Route path="/AdminReports" element={<AdminReports />} />
          <Route path="/News" element={<News />} />
          <Route path="/NewsAdmin" element={<NewsAdmin />} />
          <Route path="/news/:newsSlug" element={<NewsArticle />} />
          <Route path="/Music" element={<Music />} />
          <Route path="/Groups" element={<Groups />} />
          <Route path="/CreateGroup" element={<CreateGroup />} />
          <Route path="/Group/:groupSlug" element={<Group />} />

        </Routes>
      </Router>
  );
}

export default App;
